{
  "appStore": {
    "url": "https://apps.apple.com/gb/app/daily-health-mobile/id6752399756",
    "isActive": true
  },
  "playStore": {
    "url": "https://play.google.com/store/apps/details?id=net.dhig.digital.customer.portal",
    "isActive": true
  }
}
